export default __webpack_public_path__ + "static/media/no-entry.af978642.svg";